var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 494.91 499.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.17,499.93H125.4C56.15,499.93,0,443.78,0,374.52v-192.76C0,112.5,56.15,56.35,125.4,56.35h139.92c11.54,0,20.9,9.36,20.9,20.9h0c0,11.54-9.36,20.9-20.9,20.9H125.4c-46.17,0-83.6,37.43-83.6,83.6v192.76c0,46.17,37.43,83.6,83.6,83.6h192.76c46.17,0,83.6-37.43,83.6-83.6v-149.89c0-11.54,9.36-20.9,20.9-20.9h0c11.54,0,20.9,9.36,20.9,20.9v149.89c0,69.26-56.15,125.4-125.4,125.4v.02Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.97,246.38L439.43,25.93l29.56,29.56-220.45,220.45c-8.16,8.16-21.4,8.15-29.56,0h0c-8.16-8.16-8.15-21.4,0-29.56h0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M347.6,0h126.41c11.53,0,20.9,9.37,20.9,20.9v10.9c0,5.52-4.48,10-10,10h-137.31c-11.54,0-20.9-9.37-20.9-20.9h0c0-11.53,9.36-20.9,20.9-20.9Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M453.11,147.32V20.91C453.11,9.37,462.47.01,474.01.01h0c11.54,0,20.9,9.36,20.9,20.9v126.41c0,11.54-9.36,20.9-20.9,20.9h0c-11.54,0-20.9-9.36-20.9-20.9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/redirect-icon.c2d43535a92515004497cefb0b1b6203.svg";
export { ForwardRef as ReactComponent };